import { useMemo, useState } from "react";
import Spinner from 'react-bootstrap/Spinner';
import { axiosGetWithHeader } from "../../Common/axios";
import { handleClickColor } from "../../Common/Util";

export function KPConjoinedPlanetsTable ({userData}) {
  const [chartData, setChartData] = useState([]);
  const [spinner, setSpinner] = useState('Loading - Conjoined Planets Table');

  useMemo(() => {
    if(userData===null||userData===undefined) {
      setSpinner(null);
      return;
    }
    var clientId = userData.id;
    axiosGetWithHeader("/chart/conjoinedchart/"+clientId,
      (response)=>{
        setChartData(response.data);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setChartData([]);
        setSpinner(null);
      }
    );

  }, [userData]);

    return(
      <>
        {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
        {  
          chartData===null||chartData.length===0?(
            <></>
          ):(
            <>
        <table class="table table-bordered table-hover align-middle caption-top m-0 p-0 text-center TableFont">
          <caption class="m-0 p-0" ><h5 class="m-0 p-2">Conjunction of Planets</h5></caption>
          <thead>
            <tr class="p-0 m-0 kplinktr" >
              <th class="m-0 p-1 kptable-td">Planet</th> 
              <th class="m-0 p-1 kptable-td">House</th> 
              <th class="m-0 p-1 kptable-td" >Conjoined Planets</th> 
            </tr>
          </thead>
          <tbody>
          {
            chartData.map((planet) => (
                <tr class="p-0 m-0 kplinktr"  onClick={handleClickColor}>
                    <th class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{planet[0]}</th>
                    <th class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{planet[12]}</th>
                    <td class="bg-transparent text-start m-0 p-0 ps-1 kptable-td">{planet[11]}</td>
                </tr>
            ))
        }
  
            </tbody>  
          </table>
        </>
          )}
        </>  
      );
  }